_ = require('lodash')

module.exports = (
)->
  return {
    restrict: 'A'
    template: require('./tagging-groupdisplay.html')
    scope:
      isDisabled: '&taggingGroupdisplayIsDisabled'
      getTagGroup: '&taggingGroupdisplayTagGroup'
      getSelectedTagIds: '&taggingGroupdisplayGetSelectedTagIds'
      onChooseOption: '&taggingGroupdisplayOnChooseOption'
    link: ( $scope ) ->
      $scope.model =
        option: null

      $scope.$watch $scope.getSelectedTagIds, (selectedTagIds) ->
        $scope.model.option = optionToDisplay(selectedTagIds)

      optionToDisplay = (selectedTagIds) ->
        options = $scope.getTagGroup().options

        selectedExcludeOption = _.find options, (option) -> option.exclude and not _.contains(selectedTagIds, option.id)
        selectedIncludeOption = _.find options, (option) -> not option.exclude and _.contains(selectedTagIds, option.id)

        # In all reasonable configs, we could not have the situation where
        # we want to both display an 'exclude' option and an 'include' option
        # so the order below does not matter
        return selectedExcludeOption or selectedIncludeOption
  }
